import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import Bestaetigt from './components/Bestaetigt';
import Login from './components/Login';
import BestaetigtQR from './components/BestaetigtQR';
import Insight from './components/Insight';
import DHPICK from './components/DHPICK';
import Position from './components/Position';
import Wartungsvertrag from './components/Wartungsvertrag';
import WartungsGeraet from './components/WartungsGeraet';
import Schluesselliste from './components/Schluesselliste';
import Verzeichnis from './components/Verzeichnis';
import Lagerartikel from './components/Lagerartikel';
import Carstock from './components/Carstock';
import SearchFahrzeug from './components/SearchFahrzeug';
import Planer from './components/Planer';
import Upload from './components/Upload';
import UploadArticle from './components/UploadArticle';
import Historie from './components/Historie';
import NotFound from './components/NotFound';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle';
import $ from 'jquery';
import Popper from 'popper.js';
import reportWebVitals from './reportWebVitals';
import {
  BrowserRouter,
  Routes,
  Route,
  Link,
} from "react-router-dom";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(

    <BrowserRouter>
      <Routes>
          <Route path="/" element={ <NotFound/> }/>
          <Route path="/dhworld" element={<App />} />
          <Route path="/insight" element={<Insight />} />
          <Route path="/dhpick" element={<DHPICK />} />
          <Route path="/upload" element={<Upload />} />
          <Route path="/uploadarticle" element={<UploadArticle />} />
          <Route path="/position/:dokumentNummer/:intnummer" element={<Position />} />
          <Route path="/insight/wartungsvertrag" element={<Wartungsvertrag />} />
          <Route path="/insight/wartungsgeraet" element={<WartungsGeraet />} />
          <Route path="/insight/schluesselliste" element={<Schluesselliste />} />
          <Route path="/insight/verzeichnis" element={<Verzeichnis />} />
          <Route path="/insight/lagerartikel" element={<Lagerartikel />} />
          <Route path="/carstock" element={<Carstock />} />
          <Route path="/insight/historie" element={<Historie />} />
          <Route path="/insight/planer" element={<Planer />} />
          <Route path="/dhworld/bestaetigt/:id" element={<Bestaetigt />} />
          <Route path="/dhworld/bestaetigtQR/:id" element={<BestaetigtQR />} />
          <Route path="/fahrzeug/:id" element={<SearchFahrzeug />} />
          <Route path="/dhworld/login" element={<Login />} />
      </Routes>
    </BrowserRouter>

);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
